export function mapStatusToLabel(status?: string) {
  const s = (status || '').toString().trim().toUpperCase();
  if (s === 'ACTIVE' || s === 'ATIVO' || s === '') return 'Ativo';
  if (s === 'LEAD') return 'Lead';
  if (s === 'INACTIVE' || s === 'INATIVO') return 'Inativo';
  if (s === 'AT_RISK' || s === 'EM RISCO') return 'Em Risco';
  if (s === 'VIP' || s === 'CLIENTE VIP') return 'Cliente VIP';
  if (s === 'NEGOTIATION' || s === 'NEGOCIACAO' || s === 'NEGOCIAÇÃO') return 'Negociação';
  return status || 'Ativo';
}

export function mapLabelToStatusEnum(label?: string) {
  if (!label) return 'ACTIVE';
  const v = label.toString().trim().toLowerCase();
  if (v.includes('ativ')) return 'ACTIVE';
  if (v.includes('lead')) return 'LEAD';
  if (v.includes('inativ')) return 'INACTIVE';
  if (v.includes('ris')) return 'AT_RISK';
  if (v.includes('vip')) return 'VIP';
  if (v.includes('negoc')) return 'NEGOTIATION';
  return 'ACTIVE';
}
